export enum Routes {
  Home = '/',
  Login = '/login',
  User = '/user',
}
